import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class DjPsychoPopUpView extends PIXI.Container implements StageLayer {

    private _popUpText1: PIXI.Text;
    private _popUpText2: PIXI.Text;
    private _bubbleTexture: PIXI.Sprite;
    private _popUpCount: number = 0;
    private _betBoostAllowed: boolean = false;
    private _extFreeBetsActive: boolean = false;

    constructor() {
        super();
        this.name = "DjPsychoPopUpView";
        this.init();
    }

    public onResize(): void {
        if(this._betBoostAllowed){
            this._bubbleTexture.scale.y = 1;
            if (NolimitApplication.isLandscape) {
                if (NolimitApplication.screenBounds.width <= 970) {
                    this._popUpText1.position.set(650, 100);
                    this._bubbleTexture.position.y = this._popUpText1.position.y + 45;
                } else {
                    const spinButtonWidth: number = 200,
                        spinCenterX: number = (NolimitApplication.screenBounds.right - spinButtonWidth * 0.5);
                    this._popUpText1.position = new PIXI.Point(spinCenterX - (this._popUpText1.width * 0.5), 130);
                    this._bubbleTexture.position.y = this._popUpText1.position.y + 45;
                }
            } else {
                if (NolimitApplication.screenBounds.height <= 970) {
                    this._bubbleTexture.scale.y = -1;
                    this._popUpText1.position.set(550, 170);
                    this._bubbleTexture.position.y = this._popUpText1.position.y + 15;
                } else {
                    this._popUpText1.position.set(520, -150);
                    this._bubbleTexture.position.y = this._popUpText1.position.y + 45;
                }
            }
            this._popUpText2.position.x = this._popUpText1.position.x;
            this._popUpText2.position.y = this._popUpText1.position.y + 60;
            this._bubbleTexture.position.x = this._popUpText1.position.x;
        }
    }

    public playPopUp(): void {
        this._popUpCount++;
        if (this._popUpCount === 5) {
            this.showPopUp();
        }
    }

    public resetPopUp(): void {
        this._popUpCount = 0;
    }

    public showPopUp(): void {
        if (!this._betBoostAllowed || DjPsycho.apiPlugin.freeBets.hasFreeBets() || DjPsycho.apiPlugin.freeFeatureBet.hasFreeFeatureBet() || DjPsycho.xBetView.isBtnOn() || this._extFreeBetsActive) { // #122, #125, #158, #185 condition modified
            return;
        }

        if (DjPsycho.model.isRestore || DjPsycho.apiPlugin.isReplay) {
            this.visible = false;
            return;
        }

        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                this.hidePopUp();
            }
        });
        this.alpha = 0;
        this.visible = true;

        tl.to(this, {
            duration: 0.2,
            alpha: 1
        }, 0);

        tl.to(this, {
            duration: 0.2,
            alpha: 0
        }, 5);
        this.resetPopUp();
    }

    public hidePopUp(): void {
        this.visible = false;
    }

    private init(): void {
        this._betBoostAllowed = DjPsycho.apiPlugin.gameClientConfiguration.boostedBetAllowed;
        if (this._betBoostAllowed) {
            this._bubbleTexture = new PIXI.Sprite(DjPsycho.assetLoader.getTextures("X_Bet/X_Bet_Bubble")[0]);
            this._bubbleTexture.anchor.set(0.5);

            this._popUpText1 = new PIXI.Text(DjPsycho.apiPlugin.translations.translate("3 times more likely to trigger Gees! Spinz."), new PIXI.TextStyle({
                align: "center",
                wordWrap: true,
                breakWords:true,
                wordWrapWidth: 300,
                fontFamily: OpenSans.FAMILY,
                fontWeight: FontWeight.REGULAR,
                fontSize: 18,
                fill: 0xFFFFFF
            }));
            this._popUpText1.anchor.set(0.5);

            this._popUpText2 = new PIXI.Text(DjPsycho.apiPlugin.translations.translate("7 times more likely to trigger Psycho Spinz."), new PIXI.TextStyle({
                align: "center",
                wordWrap: true,
                breakWords:true,
                wordWrapWidth: 300,
                fontFamily: OpenSans.FAMILY,
                fontWeight: FontWeight.REGULAR,
                fontSize: 18,
                fill: 0xFFFFFF
            }));
            this._popUpText2.anchor.set(0.5);

            this.visible = false;
            this.onResize();
            this.addChild(this._bubbleTexture, this._popUpText1, this._popUpText2);

            // #185
            this._extFreeBetsActive = false;
            DjPsycho.apiPlugin.events.on("extFreeRoundsInit", () => {
                this._extFreeBetsActive = true;
            });
            DjPsycho.apiPlugin.events.on("extFreeRoundsEnded", () => {
                this._extFreeBetsActive = false;
            });
        }
    }
}